import { graphql } from 'msw'
import db from '../db'

const publisherHandlers = [
  graphql.query('publishers', (req, res, ctx) => {
    const publishers = db.publisher.getAll()
    return res(ctx.data({ publishers }))
  }),

  graphql.query('publisher', (req, res, ctx) => {
    const publisher = db.publisher.get(req.variables.id)
    return res(ctx.data({ publisher }))
  }),

  graphql.query('queryPublisherFees', (req, res, ctx) => {
    const publisher = db.publisher.get(req.variables.id)

    const publisherFees = {
      revenueShareMobile: publisher.revenueShareMobile,
      revenueBonusMobile: publisher.revenueBonusMobile,
      revenueShareRiskBufferMobile: publisher.revenueShareRiskBufferMobile,
      revenueShareTransactionFeeMobile:
        publisher.revenueShareTransactionFeeMobile,
      revenueFloorTurboApplications: publisher.revenueFloorTurboApplications,
      revenueFeesHistory: publisher.revenueFeesHistory,
    }
    return res(ctx.data({ publisherFees }))
  }),

  graphql.mutation('updatePublisher', (req, res, ctx) => {
    const publisher = db.publisher.get(req.variables.id)

    if (req.variables.enabled !== undefined) {
      const { enabled } = req.variables

      db.publisher.update({
        id: publisher.id,
        enabled,
      })

      return res(
        ctx.data({
          publisher: db.publisher.get(req.variables.id),
        })
      )
    }

    const {
      revenueShareMobile,
      revenueBonusMobile,
      revenueShareRiskBufferMobile,
      revenueShareTransactionFeeMobile,
    } = req.variables

    const publisherFees = {
      revenueShareMobile,
      revenueBonusMobile,
      revenueShareRiskBufferMobile,
      revenueShareTransactionFeeMobile,
      revenueFloorTurboApplications: publisher.revenueFloorTurboApplications,
      revenueFeesHistory: [
        ...publisher.revenueFeesHistory,
        {
          dateSet: new Date().toString(),
          revenueShareMobile,
          revenueBonusMobile,
          revenueShareRiskBufferMobile,
          revenueShareTransactionFeeMobile,
        },
      ],
    }

    db.publisher.update({
      id: publisher.id,
      ...publisherFees,
    })

    return res(
      ctx.data({
        revenueShareMobile,
        revenueBonusMobile,
        revenueShareRiskBufferMobile,
        revenueShareTransactionFeeMobile,
        revenueFloorTurboApplications: publisher.revenueFloorTurboApplications,
        revenueFeesHistory: {
          dateSet: '2029-06-28T18:02:39Z',
          revenueShareMobile,
          revenueBonusMobile,
          revenueShareRiskBufferMobile,
          revenueShareTransactionFeeMobile,
        },
      })
    )
  }),
]

export default publisherHandlers
